import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { setTaxWorkflowFilter, resetTaxWorkflowFilters } from "../index";
import { TaxWorkflowFilterPayload } from "../types";

export const useTaxWorkflowFilterActions = () => {
  const dispatch = useDispatch();

  const updateFilter = useCallback(
    (payload: TaxWorkflowFilterPayload) => dispatch(setTaxWorkflowFilter(payload)),
    [dispatch]
  );

  const resetFilters = useCallback(
    () => dispatch(resetTaxWorkflowFilters()),
    [dispatch]
  );

  return { updateFilter, resetFilters };
};
